import api from "!../../../../../../../amjilt/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../amjilt/node_modules/css-loader/dist/cjs.js??clonedRuleSet-25.use[1]!../../../../../../../amjilt/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../amjilt/node_modules/laravel-mix/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-25.use[2]!../../../../../../../amjilt/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-25.use[3]!../../../../../../../amjilt/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=33c50641&prod&lang=scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};